<template>
  <div>
    <div v-show="!showUpdate" class="app-content content ">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header row">
          <div class="content-header-left col-md-9 col-12 mb-2">
            <Breadcrumb
                name="Acquiring"
                bc1="App"
                bc2="Acquiring"
                bc3="List"
                path="acquirings"
            ></Breadcrumb>
          </div>
        </div>
        <div class="content-body">
          <div class="card">
            <div class="m-2">
              <div class="row">
                <div class="col-md-6 col-6">
                  <b-form-select
                      v-model="paymentId"
                      name="paymentId"
                      size="sm"
                  >
                    <b-form-select-option value=""
                    >Filter With Payment Method
                    </b-form-select-option>
                    <b-form-select-option
                        v-for="(item, index) in paymentMethodRequestData"
                        :value="item.id"
                        :key="index"
                    >{{ item.name }}
                    </b-form-select-option>
                    <b-form-select-option
                        v-show="
                                    !paymentMethodRequestData
                                  "
                        value="Filter With Payment Method"
                    ></b-form-select-option>
                  </b-form-select>
                </div>
                <div class="col-md-6 col-6">
                  <div class="d-flex align-items-center justify-content-end">
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="$router.push({ name: 'add-acquirings' })"
                    >
                      <AddButtonText name="Acquiring" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <currencyModal
                :show="showModal"
                :currencyKey="otherDetailsKey"
                @hide="showModal = false"
                :currencyData="ohterSettingDetailsData">

            </currencyModal>

            <CommonTableStore
                :url="url"
                :tableHeaderValues="tableHeaderValues"
                :actions="actions"
                :deleteActions="deleteActions"
                :mutedData="mutedData"
                :storageKey="storageKey"
                :externalTotalRecord="externalTotalRecord"
                :showPerPage = true
                :filteredData="filteredData"
            />
          </div>
        </div>
      </div>
    </div>
    <UpdateAcquiring @back="back" v-if="showUpdate" />
  </div>
</template>

<script>

import currencyModal from "@/components/common/modals/currencyPaymentShowDataModal.vue";
import UpdateAcquiring from "@/pages/dashboard/acquirings/updateAcquiring.vue";
import AddButtonText from "@/components/common/buttons/AddButtonText.vue";

export default {
  components: {
    AddButtonText,
    currencyModal,
    UpdateAcquiring
  },
  mounted() {
    this.selectPaymentData()
    localStorage.setItem("url", "v1/get-aquiring");
    this.checkDataInStore('v1/get-aquiring')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      showUpdate:false,
      showModal: false,
      ohterSettingDetailsData: [],
      otherDetailsKey: [],
      url: "v1/get-aquiring",
      storageKey: "acquiringMain",
      paymentMethodRequestData:[],
      paymentId:'',
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name"
        },
        {
          title: "Code",
          valueKey: "code",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: "Payment Method",
          valueKey: "payment_method.name",
          html: true,
          alter: function(value,row) {
            var html = "";
            if (value) {
              html = `<span class="badge badge-info badge-sm badge-glow">${value+'/'+row.payment_method.code}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: 'Created At',
          valueKey: 'created_at',
          html:true,
          alter: (value) => {
            return `<span class="badge text-dark">${this.customFormatDateTime(value)}</span>`
          }
        },
        {
          title: 'Updated At',
          valueKey: 'updated_at',
          html:true,
          alter: (value) => {
            return `<span class="badge text-dark">${this.customFormatDateTime(value)}</span>`
          }
        },
      ],
      actions: [
        {
          title: "Update",
          class: "badge btn-primary",
          cta: (row, index) => {
            let data = {
              ...row,
              index: index,
              row: row,
              key: "acquiringMainUpdate",
              storageKey: this.storageKey,
              idx: index,
            }
            this.$store.dispatch("set", data);
            this.showUpdate = true
          }
        },
        // {
        //   title: "Groups",
        //   class: "badge btn-primary",
        //   cta: (row, index) => {
        //     let data = {
        //       index: index,
        //       row: row,
        //       key: "acquiringGroups"
        //     };
        //     this.$store.dispatch("set", data);
        //     this.$router.push({ name: "acqruiring-groups",params: {acquiringId :row.id}})
        //   }
        // },
        {
          title: "Setting Details",
          class: "badge btn-primary",
          modalId: "v-b-modal.modal-primary",
          cta: (row, index) => {
            this.showSettingsDetails(row, index);
          }
        },
        {
          title: "Transaction Types",
          class: "badge btn-warning",
          modalId: "v-b-modal.modal-primary",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "acquiringMainTransactionTypes"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "acquirings-transction-type" });
          }
        },
      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "aquireDelete"
            };
            this.deleteRecord(data);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: "",
      filteredData: {}

    };
  },
  methods: {
    back() {
      this.showUpdate = false
      this.filteredData = {}
    },
    showSettingsDetails(row) {
      this.showModal = true;
      if (row.other_details !== null && row.other_details != "[]" ) {
        if (typeof row.other_details == "object") {
          let otherDetailsKey = Object.keys(row.other_details);
          let data = row.other_details;
          this.ohterSettingDetailsData = data;
          this.otherDetailsKey = otherDetailsKey;
        } else if (typeof row.other_details == "string") {
          let ohterSettingDetailsData = JSON.parse(row.other_details);
          let otherDetailsKey = Object.keys(ohterSettingDetailsData);
          let data = ohterSettingDetailsData;
          this.ohterSettingDetailsData = data;
          this.otherDetailsKey = otherDetailsKey;
        }
      } else {
        this.ohterSettingDetailsData = [];
        this.otherDetailsKey = [];
      }
    },
    deleteRecord(data) {
      this.makeRequest("post", "v1/delete-aquiring", {
        status: data.row.status == true ? 1 : 0,
        aquiringId: data.row.id
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let storeData = this.$store.getters.getByKey(this.storageKey);
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                    typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                      storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                    typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                      storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = "acquiringMain";
              this.$store.dispatch("set", storeData);
            }
          }
        }
      });
    },
    selectPaymentData() {
      this.makeRequest("post", "v1/get-payment-method", {
        flag: "active"
      }, {},false,true,[205]).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let data = [];
            data = callResponse.response.data.data;
            this.paymentMethodRequestData = data

          }
        }
      });
    },
  },
  watch:{
    paymentId(val){
      this.filteredData = {
        paymentMethodId: val
      }
    }
  }
};
</script>

